import 'whatwg-fetch';
import { omitBy, isNil } from 'lodash';
import { auth } from './auth';
import { encodeQueryData } from './utils';

const PRODUCTION_BASE_URL = 'https://api.ddaview.com';
const STAGE_BASE_URL = 'http://localhost:3005';

const getBaseUrl = () => {
  switch (process.env.REACT_APP_BUILD) {
    case 'production':
      return PRODUCTION_BASE_URL;
    case 'stage':
      return STAGE_BASE_URL;
    default:
      return process.env.REACT_APP_LOCAL_BASE_URL || STAGE_BASE_URL;
  }
};

export const API_BASE_URL = `${getBaseUrl()}/api`;
export const API_SOCKET_URL = getBaseUrl();

function parseJSON(response) {
    console.log('response', response)

  return response.status !== 204 && response.json();
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error();
  error.status = response.status;
  error.statusText = response.statusText;
  return response
    .json()
    .then(body => {
      error.body = body;
    })
    .catch(() => {}) // Catch body parsing errors and continue
    .then(() => {
      throw error;
    });
}

function getHeaders(contentType) {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  if (auth.loggedIn) {
    headers.Authorization = `Bearer ${auth.getToken()}`;
  }
  return headers;
}

export function request(url, options) {
  const cleanOptions = omitBy(options, isNil);
  return fetch(url, cleanOptions).then(checkStatus).then(parseJSON);
}

export function post(url, body) {
  const cleanBody = omitBy(body, isNil);
  return request(`${API_BASE_URL}${url}`, {
    method: 'POST',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    body: JSON.stringify(cleanBody),
  });
}

export function get(url, params) {
  const urlParams = encodeQueryData(omitBy(params, isNil));
  const urlStr = urlParams ? `${API_BASE_URL}${url}?${urlParams}` : `${API_BASE_URL}${url}`;
  return request(urlStr, {
    method: 'GET',
    headers: getHeaders(),
  });
}

export function remove(url) {
  return request(`${API_BASE_URL}${url}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
}

export function put(url, body) {
  const cleanBody = omitBy(body, isNil);
  return request(`${API_BASE_URL}${url}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(cleanBody),
  });
}

export function postForm(url, formData) {
  return request(`${API_BASE_URL}${url}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${auth.getToken()}` },
    body: formData,
  });
}
